import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); toast.success("Thanks for joining the list!"); setEmail(""); }
    catch { toast.error("Please enter a valid email."); }
  };
  return (
    <footer className="bg-brand-ink text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="font-serif-display text-2xl mb-3">Crochet Kerry</div>
          <p className="text-sm text-white/70 leading-relaxed">Handmade crochet winter wear, lovingly crafted in my UK home studio.</p>
          <div className="flex items-center gap-4 mt-4">
            <a href="https://www.instagram.com/crochet_kerry/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-brand-pink transition-colors" data-testid="footer-instagram">
              <Instagram className="w-4 h-4" /> @crochet_kerry
            </a>
            <a href="https://www.pinterest.com/CrochetKerry/" target="_blank" rel="noreferrer" aria-label="Pinterest" className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-brand-pink transition-colors" data-testid="footer-pinterest">
              <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true"><path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345c-.091.378-.293 1.194-.333 1.361-.052.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>
              Pinterest
            </a>
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-luxe mb-4 text-brand-pink">Shop</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/shop" className="hover:text-white transition-colors" data-testid="footer-shop-all">Shop All</Link></li>
            <li><Link to="/shop?new_arrival=true" className="hover:text-white transition-colors">New Arrivals</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-luxe mb-4 text-brand-pink">Help</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/faqs" className="hover:text-white transition-colors">FAQs</Link></li>
            <li><Link to="/delivery-returns" className="hover:text-white transition-colors">Delivery & Returns</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About Kerry</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-luxe mb-4 text-brand-pink">Join the list</h4>
          <p className="text-sm text-white/70 mb-3">Get 10% off your first order and early access to new makes.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
              className="flex-1 bg-white/10 border border-white/20 rounded-sm px-3 py-2 text-sm outline-none focus:border-brand-pink" data-testid="footer-newsletter-input" />
            <button className="bg-brand-pink text-brand-ink px-4 rounded-sm text-sm hover:bg-white transition-colors" data-testid="footer-newsletter-submit"><Mail className="w-4 h-4" /></button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Crochet Kerry. All prices in GBP incl. applicable taxes.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors">Cookies</Link>
            <Link to="/accessibility" className="hover:text-white transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
